import React from "react";
import { useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const domain   = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE; // optional

  // If VITE_BASE_URL is missing, fall back to current origin
  const baseUrl = import.meta.env.VITE_BASE_URL || window.location.origin;
  const redirectUri = `${baseUrl}/callback`;

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  if (!domain || !clientId) {
    // Optional: helps catch misconfig during dev
    // eslint-disable-next-line no-console
    console.error("Auth0 missing env: VITE_AUTH0_DOMAIN or VITE_AUTH0_CLIENT_ID");
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        ...(audience ? { audience } : {}),
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;
